import { render, staticRenderFns } from "./EduRecordsData.vue?vue&type=template&id=563038be"
import script from "./EduRecordsData.vue?vue&type=script&lang=js"
export * from "./EduRecordsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports